import { ICreateReceipt } from 'src/types/CreateReceipt';
import { IOfflineSupplier } from 'src/types/OfflineSupplier';
import { IPO } from 'src/types/PO';
import { IPostBody } from 'src/types/PostBody';
import axios from 'src/utils/axios';

import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'src/app/store';
type poPostRequest = {
  data: IPostBody;
  companyId: string;
  itemNumber?: string;
};
type createReceiptParams = {
  supplierId?: string;
  poId?: string;
  companyId: string;
};
type gridPODataState = {
  POData: IPO[];
  POLoading: 'loading' | 'pending' | 'succeeded' | 'failed';
  POTotal: number;
  offlineSupplierData: IOfflineSupplier[];
  supplierTotal: number;
  supplierLoading: 'loading' | 'pending' | 'succeeded' | 'failed';
  createReceiptData: ICreateReceipt | undefined;
  createReceiptLoading: 'loading' | 'pending' | 'succeeded' | 'failed';
};

const initialState = {
  POData: [],
  POTotal: 0,
  POLoading: 'loading',
  offlineSupplierData: [],
  supplierTotal: 0,
  supplierLoading: 'loading',
  createReceiptData: undefined,
  createReceiptLoading: 'loading',
} as gridPODataState;

export const fetchPOGridData = createAsyncThunk(
  'PO/fetchPOGridData',
  async ({ data, companyId, itemNumber }: poPostRequest) => {
    const response = await axios.post(`po/filter`, data, { params: { companyId, itemNumber } });
    return response.data;
  }
);
export const fetchSupplierGridData = createAsyncThunk('PO/fetchSupplierGridData', async () => {
  const response = await axios.get(`/supplier/offline`);
  return response.data;
});
export const createReceipt = createAsyncThunk(
  'PO/createReceipt',
  async (data: createReceiptParams) => {
    const response = await axios.post(`/receipt`, data);
    return response.data;
  }
);

export const poGridSlice = createSlice({
  name: 'PO',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        fetchPOGridData.fulfilled,
        (state, action: PayloadAction<{ items: IPO[]; totalRecords: number }>) => {
          state.POData = action.payload.items;
          state.POTotal = action.payload.totalRecords;
          state.POLoading = 'succeeded';
        }
      )
      .addCase(fetchPOGridData.rejected, (state) => {
        state.POLoading = 'failed';
      })
      .addCase(fetchPOGridData.pending, (state) => {
        state.POLoading = 'pending';
      })
      .addCase(
        fetchSupplierGridData.fulfilled,
        (state, action: PayloadAction<IOfflineSupplier[]>) => {
          state.offlineSupplierData = action.payload;
          state.supplierTotal = action.payload.length;
          state.supplierLoading = 'succeeded';
        }
      )
      .addCase(fetchSupplierGridData.rejected, (state) => {
        state.supplierLoading = 'failed';
      })
      .addCase(fetchSupplierGridData.pending, (state) => {
        state.supplierLoading = 'pending';
      })
      .addCase(createReceipt.fulfilled, (state, action: PayloadAction<ICreateReceipt>) => {
        state.createReceiptData = action.payload;
        state.supplierLoading = 'succeeded';
      })
      .addCase(createReceipt.rejected, (state) => {
        state.supplierLoading = 'failed';
      })
      .addCase(createReceipt.pending, (state) => {
        state.supplierLoading = 'pending';
      });
  },
});

export const selectPOUse = (state: RootState) => state.pos;
export default poGridSlice.reducer;
